import { render } from "./Payments.vue?vue&type=template&id=02611029&scoped=true"
import script from "./Payments.vue?vue&type=script&lang=js"
export * from "./Payments.vue?vue&type=script&lang=js"

import "./Payments.vue?vue&type=style&index=0&id=02611029&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-02611029"

export default script